import { Dropdown, Text } from "@100mslive/react-ui";
import { useTranslation } from "react-i18next";

import { ExpandIcon } from "@100mslive/react-icons";
import { FEATURE_LIST } from "../../common/constants";
import React from "react";
import { useFullscreen } from "../hooks/useFullscreen";
import { useIsFeatureEnabled } from "../hooks/useFeatures";

export const FullScreenItem = () => {
  const { allowed, isFullscreen, toggleFullscreen } = useFullscreen();
  const isFullscreenEnabled = useIsFeatureEnabled(FEATURE_LIST.FULLSCREEN);
  const { t } = useTranslation();

  if (!isFullscreenEnabled || !allowed) {
    return null;
  }

  return (
    <Dropdown.Item
      onClick={() => {
        toggleFullscreen();
      }}
      data-testid="full_screen_btn"
    >
      <ExpandIcon />
      <Text variant="sm" css={{ ml: "$4" }}>
        {t("fm_toggle_fullscreen", 
          {
            text: isFullscreen ? t("lbl_close") : t("lbl_open")
          }
        )}
      </Text>
    </Dropdown.Item>
  );
};
